import { CloudUpload } from "@material-ui/icons";
import React, { useContext, useEffect, useRef, useState } from "react";
import {
  Grid,
  IconButton,
  InputAdornment,
  MenuItem,
  TextField,
} from "@material-ui/core";
import FlexView from "react-flexview/lib";
import { SkyInformationPopover } from "../../Core/Popover/SkyPopover";
import { fleetUses } from "../../../Constants";
import { BuyingInsuranceContextStore } from "../../../context/BuyingInsuranceContext";
import { ACTIONS, UserProfileContextStore } from "../../../context/UserProfileContext";
import { Action } from '../../../models/Action';
import { EventEmitterService, EventKey } from "../../../services/EventEmitterService";
import { SessionContextStore } from "../../../context/SessionContext";
import { CustomizedRequestSupportTagFleet, RequesetSupportTag } from "../../Core/RequestSupportTag";

const acceptedFileTypes = [".csv", ".xls", "xlsx"].join(",");

export default (props) => {
  const context = useContext(UserProfileContextStore)
  const sessionContext = useContext(SessionContextStore)
  const [error, setError] = useState(null);
  const [fileName, setFileName] = useState(null);
  const ref = useRef();

  React.useEffect(() => {
    let id = EventEmitterService.subscribe(
      EventKey.USER_PROFILE_SAVE,
      async () => {
        if (ref.current.files.length !== 0 || sessionContext.user.fleetDocumentName) {
          context.dispatch({type: ACTIONS.SAVE_FLEET, data: ref.current.files[0]});
          setError(null);
        } else {
          setError("Check for required fields/invalid data");
        }
      }
    );

    if(sessionContext.user.fleetDocumentName) {
      setFileName(sessionContext.user.fleetDocumentName);
    }

    return () => {
      EventEmitterService.unsubscribe(EventKey.USER_PROFILE_SAVE, id);
    };
  }, [sessionContext.user.fleetDocumentName]);

  // useEffect(() => {
  //   if(sessionContext.user.fleetDocumentName) {
  //       setFileName(sessionContext.user.fleetDocumentName);
  //   }
  // }, [sessionContext.user.fleetDocumentName])

  return (
    <>
      <input
        type="file"
        id="file"
        accept={acceptedFileTypes}
        onChange={(e) => setFileName(e.target.files[0].name)}
        ref={ref}
        style={{ display: "none" }}
      />
      <div className="text-body grey margin-top-medium margin-bottom-medium">
      Before coverage is purchased, you must upload fleet details. 
      <br/>
      The fleet should include model and serial numbers (FAA# optional). 
      <br/>
      Only those drones clearly and individually listed on the uploaded document will be insured under the policy.       
      </div>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <TextField
            disabled
            fullWidth
            onClick={() => ref.current.click()}
            variant="outlined"
            className="margin-right-basic"
            label={fileName ?? "Upload file"}
            error={!!error}
            InputProps={{
              endAdornment: (
                <InputAdornment position="start">
                  <span>{`(CSV, XLS)`}</span>
                  <IconButton>
                    <CloudUpload />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </Grid>
        <CustomizedRequestSupportTagFleet/>
      </Grid>
    </>
  );
};
